import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";

import Imagen1 from "../../../images/modulo12/damacao.png";
import Imagen2 from "../../../images/modulo12/convento.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad4 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[6];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[7].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[7].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[5].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[5].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-4 p-md-3">
          <h2 className="mb-4">Las mujeres en nuestra historia</h2>

            <p>
              Hace muchos años, antes de que los españoles llegaran al Perú,
              había mujeres gobernantes, sacerdotisas, guerreras, artesanas,
              pastoras y agricultoras. Algunas eran{" "}
              <strong>muy poderosas</strong> como las sacerdotisas. Ellas se
              encargaban del culto a los dioses y, por ello, controlaban a la
              población.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Años más tarde, las mujeres{" "}
              <strong>dejaron de ocupar altos cargos.</strong> Hubo mujeres
              españolas, mulatas, negras, indias y mestizas. En ese tiempo, los
              conventos y los monasterios fueron lugares importantes para las
              mujeres. Ahí podían tener educación y vivir con cierta
              independencia.
            </p>
            <p>
              Durante el siglo XIX, las mujeres participaron en las{" "}
              <strong>guerras</strong> de independencia y en la guerra con
              Chile.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida a niños y niñas que en silencio lean el texto titulado Las
            mujeres en nuestra historia. Pregunte a niños y niñas si creen que
            el rol que las mujeres han tenido en la sociedad peruana siempre ha
            sido el mismo. Luego de escuchar sus respuestas, comente que,
            justamente el texto nos muestra que el rol y la posición de la mujer
            han cambiado a lo largo de la historia del Perú y que estos no
            siempre han estado supeditados a la actividad masculina. Lea una vez
            más el texto en voz alta.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
